export const ANSWER_SELECT = 'ANSWER_SELECT';
export const UPDATE_VIEW = 'UPDATE_VIEW';
export const UPDATE_VIEW_COLOR = 'UPDATE_VIEW_COLOR';
export const UPDATE_QUESTION = 'UPDATE_QUESTION';
export const RECEIVE_QUESTIONS = 'RECEIVE_QUESTIONS';
export const REFRESH_QUESTIONS = 'REFRESH_QUESTIONS';
export const RECEIVE_BASE_DATA = 'RECEIVE_BASE_DATA';
export const RECEIVE_THEMES = 'RECEIVE_THEMES';
export const UPDATE_LOADING = 'UPDATE_LOADING';
export const UPDATE_COVER = 'UPDATE_COVER';
export const UPDATE_LAYOUT = 'UPDATE_LAYOUT';
export const SHOW_ABOUT = 'SHOW_ABOUT';
export const TALLY_RESULTS = 'TALLY_RESULTS';
export const UPDATE_RESULT = 'UPDATE_RESULT';
export const RESTART = 'RESTART';

export const dataLoaded = ({ questions, pool, beauty, app, archetypes, themes, loading, viewId, viewColor }) => ([
  receiveQuestions({ questions, pool, beauty }),
  receiveBaseData({ app, archetypes }),
  receiveThemes({ themes, shuffle: true }),//themes.sort((a, b) => (a.name > b.name) ? 1 : -1)),
  updateViewColor(viewColor),
  updateLoading(loading),
  updateView(viewId)
])

export const answerSelect = index => ({
  type: ANSWER_SELECT, index
});

export const refreshQuestions = () => ({
  type: REFRESH_QUESTIONS
});

export const updateQuestion = ({ current, prev }) => ({
  type: UPDATE_QUESTION, current, prev
});

export const updateView = id => ({
  type: UPDATE_VIEW, id
});

export const updateViewColor = color => ({
  type: UPDATE_VIEW_COLOR, color
});

export const receiveQuestions = ({ questions, pool, beauty, themes }) => ({
  type: RECEIVE_QUESTIONS, questions, pool, beauty, themes
});

export const receiveThemes = ({ themes, shuffle = false }) => ({
  type: RECEIVE_THEMES, themes, shuffle
});

export const receiveBaseData = ({ app, archetypes }) => ({
  type: RECEIVE_BASE_DATA, app, archetypes
});

export const updateLoading = loading => ({
  type: UPDATE_LOADING, loading
});

export const showAbout = visible => ({
  type: SHOW_ABOUT, visible
});

export const updateCover = data => ({
  type: UPDATE_COVER, data
});

export const updateLayout = mobile => ({
  type: UPDATE_LAYOUT, mobile
});

export const tallyResults = () => ({
  type: TALLY_RESULTS
});

export const updateResult = result => ({
  type: UPDATE_RESULT, result
});

export const restart = poolIndex => ({
  type: RESTART, poolIndex
});
